// extracted by mini-css-extract-plugin
module.exports = {"content":"Menu_content__gmk1Q","items":"Menu_items__uEWZt","arrow":"Menu_arrow__51cPs"};